var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"articleStory"},[_c('GovAnnounceHead',{attrs:{"info":_vm.info,"staticData":_vm.staticData}}),_c('GovAnnounceBody',{attrs:{"info":_vm.info,"staticData":_vm.staticData}}),_c('GovAnnounceFoot',{attrs:{"info":_vm.info,"staticData":_vm.staticData,"followStatus":_vm.followStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }